import qs from "query-string";
import { setUserDataInDataLayer } from "../../analytics/ga4-helper";
import axios from "../../fetch-api/fetch-api";
import { IUserSession, IUserSessionUI } from "../../interfaces/session/user-session-v3";
import { setCustomerBrowserId } from "./setCustomerBrowserId";

export function refreshAuth(): Promise<IUserSessionUI> {
  return new Promise((resolve, reject) => {
    const queryString = window.location.search;
    const query = qs.parse(queryString);
    const { store } = query;
    axios.post<IUserSession>("/user-session-v3", store ? { store } : null)
      .then(({ data }) => {
        setCustomerBrowserId(data.customerBrowserId);
        setUserDataInDataLayer(data.customerBrowserId);
        resolve(data);
      })
      .catch((e: Error) => reject(e));
  });
}
